import { render, staticRenderFns } from "./WaitBox.vue?vue&type=template&id=c66e27d8&"
import script from "./WaitBox.vue?vue&type=script&lang=js&"
export * from "./WaitBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports